import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  
  return (
    <motion.footer 
      className="bg-gray-800 text-white py-6 mt-auto"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8 }}
    >
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center gap-4">
          <div className="flex flex-col items-center">
            <p className="text-sm mb-2">{t('footer.follow_us', 'Obserwuj nas')}</p>
            <div className="flex gap-4">
              <motion.a
                href="https://www.facebook.com/WOPRChodziez" 
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-80 transition-opacity"
                whileHover={{ scale: 1.2, rotate: 5 }}
                whileTap={{ scale: 0.9 }}
              >
                <img 
                  src={`${process.env.PUBLIC_URL}/images/icons/fb_icon.svg`}
                  alt="Facebook"
                  className="w-6 h-6 filter invert"
                />
              </motion.a>
              <motion.a
                href="https://www.instagram.com/chodzieskiewopr/" 
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-80 transition-opacity"
                whileHover={{ scale: 1.2, rotate: -5 }}
                whileTap={{ scale: 0.9 }}
              >
                <img 
                  src={`${process.env.PUBLIC_URL}/images/icons/instagram_icon.svg`}
                  alt="Instagram"
                  className="w-6 h-6 filter invert"
                />
              </motion.a>
            </div>
          </div>
          <div className="text-center">
            <p className="text-sm">
              {t('footer.copyright', { year: currentYear, defaultValue: `© ${currentYear} Chodzieskie WOPR | Maksymilian Pływaczyk. Wszelkie prawa zastrzeżone.` })}
            </p>
          </div>
        </div>
      </div>
    </motion.footer>
  );
};

export default Footer;
